<template>
  <header class="app-head">
    <img
      :alt="app.displayName"
      class="app-icon"
      :src="app.avatarUri"
      v-if="app.avatarUri"
    />
    <img
      :alt="app.displayName"
      class="app-icon"
      src="https://console.dialogflow.com/api-client/assets/img/logo-short.png"
      v-else
    />

    <div class="app-info">
      <div class="app-name">{{ app.displayName }}</div>
      <div class="app-description">
        Powered by
        <a target="_blank" rel="noopener noreferrer" href="https://elife.com.br"
          >Elife</a
        >
      </div>
    </div>
  </header>
</template>

<style lang="sass" scoped>
@media only screen and (min-width: 601px)
  .app-head
      z-index: 666
      padding: 16px
      width: 100%
      background-color: white
      box-sizing: border-box
      display: flex
      align-items: center
      border-bottom: 1px solid #F1F3F4
      .app-icon
          max-height: 45px
          margin-left: 10px
          object-fit: cover
      .app-info
          display: inline-block
          margin-left: 22px
          .app-name
              font-size: 20px
              font-weight: 500
              color: #202124
          .app-description
              font-size: 10px
              margin-top: 2px
              opacity: .6
              a[href]
                  color: black
                  text-decoration: none
@media only screen and (max-width: 600px)
  .app-head
      z-index: 666
      padding: 2px
      width: 100%
      background-color: white
      box-sizing: border-box
      display: flex
      align-items: center
      border-bottom: 1px solid #F1F3F4
      .app-icon
          max-height: 35px
          margin-left: 10px
          object-fit: cover
      .app-info
          display: inline-block
          margin-left: 18px
          .app-name
              font-size: 14px
              font-weight: 500
              color: #202124
          .app-description
              font-size: 9px
              opacity: .6
              a[href]
                  color: black
                  text-decoration: none
</style>

<script>
export default {
  name: "TopHead",
  props: ["app"]
};
</script>
